import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication-service.service';
import { tap } from 'rxjs/operators';
import { isNullOrEmpty } from '../utils/common-functions';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const token = this.authenticationService.currentToken;
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const refreshToken = event.headers.get('RefreshToken');
          if (!isNullOrEmpty(refreshToken)) {
            this.authenticationService.currentToken = refreshToken as string;
          }
        }
        return event;
      }));
  }
}
